module.exports = __webpack_public_path__ + "static/media/download_all.a067db07.png";